import { combineReducers } from 'redux';
import authReducer from './authReducer';
import botReducer from './createBotReducer';
import futureBotReducer from './createFutureBotReducer';
import botStatusReducer from './botStatusReducer';
import futureBotStatusReducer from './futureBotStatusReducer';
import botHistoryReducer from './botHistoryReducer';
import fetchKeysReducer from './listKeysReducer';
import userSettingsReducer from './userSettingsReducer';
import userFutureSettingsReducer from './userFutureSettingsReducer';
import generateBuyLinkReducer from './generateBuyLinkReducer';
import subscriptionReducer from './subscriptionReducer';
import bidErrorReducer from './bidErrorReducer';
import futureBidErrorReducer from './futureBidErrorReducer';
import securityReducer from './securityReducer';
import affiliateReducer from './affiliateReducer';
import userReducer from './userReducer';
import withdrawlReducer from './withdrawlReducer';
import balanceReducer from './balanceReducer';
import futureBotHistoryReducer from './futureBotHistoryReducer';

export default combineReducers({
  auth: authReducer,
  createBot: botReducer,
  createFutureBot: futureBotReducer,
  botStatus: botStatusReducer,
  futureBotStatus: futureBotStatusReducer,
  botHistory: botHistoryReducer,
  futureBotHistory: futureBotHistoryReducer,
  listKeys: fetchKeysReducer,
  settings: userSettingsReducer,
  futureSettings: userFutureSettingsReducer,
  buyData: generateBuyLinkReducer,
  subscriptionData: subscriptionReducer,
  errorBids: bidErrorReducer,
  futureErrorBids: futureBidErrorReducer,
  security: securityReducer,
  affiliate: affiliateReducer,
  user: userReducer,
  withdrawl: withdrawlReducer,
  balance: balanceReducer,
});
